var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvanture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638:4485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08512 19.9958C5.09402 16.2762 7.01657 12.88 9.671 10.1289C12.3254 7.37779 15.6241 5.36284 19.2552 4.27344",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.759 48.4679C17.8562 47.8473 13.2964 45.5772 9.80149 42.0167C6.30657 38.4563 4.07617 33.809 3.46345 28.8105",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5284 28.8105C46.9153 33.8102 44.6838 38.4585 41.1872 42.0191C37.6907 45.5797 33.1291 47.849 28.2248 48.4679",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3136 3.54883C33.1929 4.18498 37.7271 6.45432 41.2047 10.0016C44.6823 13.5489 46.9066 18.173 47.5284 23.1483",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8882 37.9324C20.6645 37.4236 18.6291 36.2792 17.0205 34.6332C15.4119 32.9872 14.2966 30.9078 13.8056 28.6387",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1863 28.6543C36.6911 30.9229 35.5711 32.9997 33.9579 34.6416C32.3447 36.2835 30.3054 37.4222 28.0795 37.9231",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0875 14.0605C30.3014 14.5635 32.3304 15.6957 33.9392 17.3259C35.5481 18.9561 36.6711 21.018 37.1782 23.2722",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8137 23.3037C14.3164 21.0493 15.4357 18.9861 17.042 17.3542C18.6482 15.7223 20.6754 14.5885 22.8882 14.084",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4083 1.0293H24.5917C23.7 1.0293 22.9771 1.76639 22.9771 2.67565V13.9943C22.9771 14.9036 23.7 15.6407 24.5917 15.6407H26.4083C27.3 15.6407 28.023 14.9036 28.023 13.9943V2.67565C28.023 1.76639 27.3 1.0293 26.4083 1.0293Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4083 36.3594H24.5917C23.7 36.3594 22.9771 37.0965 22.9771 38.0057V49.3244C22.9771 50.2336 23.7 50.9707 24.5917 50.9707H26.4083C27.3 50.9707 28.023 50.2336 28.023 49.3244V38.0057C28.023 37.0965 27.3 36.3594 26.4083 36.3594Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3761 23.4277H37.2751C36.3834 23.4277 35.6605 24.1648 35.6605 25.0741V26.9262C35.6605 27.8355 36.3834 28.5726 37.2751 28.5726H48.3761C49.2679 28.5726 49.9908 27.8355 49.9908 26.9262V25.0741C49.9908 24.1648 49.2679 23.4277 48.3761 23.4277Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7249 23.4277H2.62387C1.7321 23.4277 1.00918 24.1648 1.00918 25.0741V26.9262C1.00918 27.8355 1.7321 28.5726 2.62387 28.5726H13.7249C14.6166 28.5726 15.3396 27.8355 15.3396 26.9262V25.0741C15.3396 24.1648 14.6166 23.4277 13.7249 23.4277Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638:4485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanture);
export default __webpack_public_path__ + "static/media/advanture.2c23dd82.svg";
export { ForwardRef as ReactComponent };